import React from 'react'
import { PrimaryButton } from '@softura/fluentuipackage'
import './PrimaryButton.scss'

interface IProps {
  iconProps?:any,
  menuIconProps?:any,
  text?: string,
  onClick?: any,
  className?: string | number,
  imgSrc?: any,
  children?: any,
  disabled?:any,
  id?:any,
}
const PrimaryButtonContainer = ({
  text = '',
  className = '',
  imgSrc = null,
  onClick,
  menuIconProps = null,
  iconProps = null,
  children = null,
  disabled = false,
  id
}:IProps) => {
  return (<>
     <PrimaryButton
        text = {text}
        className = {`primary-btn ${className}`}
        imgSrc = {imgSrc}
        onClick = {onClick}
        iconProps = {iconProps}
        menuIconProps = {menuIconProps}
        disabled={disabled}
        id={id}
      >
        {children}
      </PrimaryButton>
    </>
  )
}

export default PrimaryButtonContainer
